import {Component} from '@angular/core';
import {AppComponent} from '../../app.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container">
                <img id="footer-logo"   [src]="'assets/layout/images/logo-'+ (app.colorScheme === 'light' ? 'dark' : 'light') + '.png'" alt="insight-gainer-layout"/>
                <span class="app-name">{{'appName' | translate}}</span>
            </div>
            <span class="copyright">{{'copyRight' | translate}}</span>
        </div>
    `,
    imports: [
        TranslateModule,
    ],
})
export class AppFooterComponent {
    constructor(public app: AppComponent) {}
}
